import { cn } from "@/lib/cn";
import { isValidUrl } from "@library/shared";

interface Props {
  src: string;
  className?: string;
}

export const PdfLinkToSrc = ({ src, className = "" }: Props) => {
  if (!(src.trim().length > 2 && src.includes("."))) return null;

  let url = isValidUrl(src) ? src : undefined;
  if (url && !url.includes("https://")) {
    if (url.includes("http://")) url = url.replace("http", "https");
    else url = "https://" + url;
  }
  return (
    <a
      href={url}
      target="_blank"
      className={cn("pdf-link-to-src", {
        [className]: !!className,
      })}
      data-sd-cid="xI2SXa3pBEqdL9dz"
      rel="noreferrer"
    >
      {src}
    </a>
  );
};
